export var LicenseState;
(function (LicenseState) {
    LicenseState["active"] = "premium";
    LicenseState["inactive"] = "free";
})(LicenseState || (LicenseState = {}));
